import baseConfig from '../config';

// Try to load local config, use empty objects if not found
let local_base = {};
let local_frontend = {};

try {
  // Use Vite's import.meta.glob to synchronously import the local config
  // The { eager: true } option ensures the module is loaded synchronously
  const localConfigModules = import.meta.glob(['../config.local.ts', '/config.local.ts'], { eager: true });

  // Try both possible paths for the config
  const possiblePaths = ['../config.local.ts', '/config.local.ts'];
  let localConfigModule;

  // Check each path
  for (const path of possiblePaths) {
    if (localConfigModules[path]) {
      localConfigModule = localConfigModules[path];
      console.log(`[config] Found local config at ${path}`);
      break;
    }
  }

  // Apply the local config if found
  if (localConfigModule) {
    local_base = (localConfigModule.config_local || {}).config_base || {};
    local_frontend = (localConfigModule.config_local || {}).config_frontend || {};
  } else {
    console.log('[config] No local config found, using default config');
  }
} catch (error) {
  console.log('[config] No local config found, using empty config');
}

const config_demo = {
  // Demo-specific overrides if needed
};

const config_test = {
  // Test-specific subdomain config
  sentryUrl: 'https://5186cd19f98e4077a5c9ed9ebea39b8c@o491290.ingest.sentry.io/6751078',
  admin5Url: 'https://admin5-test.hopdrive.io/',
};

const config_prod = {
  // Production-specific subdomain config
  admin5Url: 'https://admin5.hopdrive.io/',
};

// Initialize config with all settings except local ones
const config = {
  ...baseConfig,

  // Firebase config
  firebaseApiKey: process.env.VITE_FIREBASE_API_KEY || (import.meta.env || {}).VITE_FIREBASE_API_KEY,
  firebaseProjectId: process.env.VITE_FIREBASE_PROJECT_ID || (import.meta.env || {}).VITE_FIREBASE_PROJECT_ID,
  firebaseAuthDomain: process.env.VITE_FIREBASE_AUTH_DOMAIN || (import.meta.env || {}).VITE_FIREBASE_AUTH_DOMAIN,
  firebaseStorageBucket:
    process.env.VITE_FIREBASE_STORAGE_BUCKET || (import.meta.env || {}).VITE_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId:
    process.env.VITE_FIREBASE_MESSAGING_SENDER_ID || (import.meta.env || {}).VITE_FIREBASE_MESSAGING_SENDER_ID,
  firebaseAppId: process.env.VITE_FIREBASE_APP_ID || (import.meta.env || {}).VITE_FIREBASE_APP_ID,
  firebaseMeasurementId:
    process.env.VITE_FIREBASE_MEASUREMENT_ID || (import.meta.env || {}).VITE_FIREBASE_MEASUREMENT_ID,
  firebasePrivateKey: process.env.VITE_FIREBASE_PRIVATE_KEY || (import.meta.env || {}).VITE_FIREBASE_PRIVATE_KEY,

  // Stripe (publishable key only — the secret key lives in the functions' env)
  stripePublishableKey: process.env.VITE_STRIPE_PK || (import.meta.env || {}).VITE_STRIPE_PK,

  // Google config
  googleApiKey: process.env.VITE_GOOGLE_API_KEY || (import.meta.env || {}).VITE_GOOGLE_API_KEY,
  googleMapsKey: process.env.VITE_GOOGLE_KEY || (import.meta.env || {}).VITE_GOOGLE_KEY,
  googlePlacesKey: process.env.VITE_GPLCS || (import.meta.env || {}).VITE_GPLCS,

  // Auth0 config
  auth0ClientId: process.env.VITE_A0_CID || '',

  // Environment specific keys
  ...config_test, //opinionated default to test
  ...(baseConfig.appEnv === 'demo' ? config_demo : null),
  ...(baseConfig.appEnv === 'test' ? config_test : null),
  ...(baseConfig.appEnv === 'prod' || baseConfig.appEnv === 'production' ? config_prod : null),

  // Local must always be last to ensure it overrides all other configs
  ...local_base,
  ...local_frontend,
};

/** Admin Portal (Admin 5) URL for the current environment — test vs prod resolved here. */
export const ADMIN5_URL: string = (config as { admin5Url?: string }).admin5Url ?? '';

export default config;
